function _extends2() { _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends2.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Generated with Packemon: https://packemon.dev
// Platform: browser, Support: stable, Format: esm
import React from 'react';
import { Matcher } from 'interweave';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function Link(_ref) {
  var children = _ref.children,
      href = _ref.href,
      onClick = _ref.onClick,
      newWindow = _ref.newWindow;
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    target: newWindow ? '_blank' : undefined,
    onClick: onClick,
    rel: "noopener noreferrer"
  }, children);
}

function Email(_ref2) {
  var children = _ref2.children,
      email = _ref2.email,
      emailParts = _ref2.emailParts,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "email", "emailParts"]);

  return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
    href: "mailto:" + email
  }), children);
}
/* eslint-disable unicorn/better-regex */


function combinePatterns(patterns, options) {
  if (options === void 0) {
    options = {};
  }

  var regex = patterns.map(function (pattern) {
    return pattern.source;
  }).join(options.join || '');

  if (options.capture) {
    regex = "(" + regex + ")";
  } else if (options.nonCapture) {
    regex = "(?:" + regex + ")";
  }

  if (options.match) {
    regex += options.match;
  }

  return new RegExp(regex, options.flags || '');
} // https://www.ietf.org/rfc/rfc3986.txt
// https://blog.codinghorror.com/the-problem-with-urls/
// http://www.regular-expressions.info/email.html


var VALID_ALNUM_CHARS = /[a-z0-9]/;
var VALID_PATH_CHARS = /(?:[a-zA-Z\u0400-\u04FF0-9\-_~!$&'()[\]\\/*+,;=.%]*)/;
var URL_SCHEME = /(https?:\/\/)?/;
var URL_AUTH = combinePatterns([/[a-z\u0400-\u04FF0-9\-_~!$&'()*+,;=.:]+/, // Includes colon
/@/], {
  capture: true,
  match: '?'
});
var URL_HOST = combinePatterns([/(?:(?:[a-z0-9](?:[-a-z0-9_]*[a-z0-9])?)\.)*/, // Subdomain
/(?:(?:[a-z0-9](?:[-a-z0-9]*[a-z0-9])?)\.)/, // Domain
/(?:[a-z](?:[-a-z0-9]*[a-z0-9])?)/ // TLD
], {
  capture: true
});
var URL_PORT = /(?::(\d{1,5}))?/;
var URL_PATH = combinePatterns([/\//, combinePatterns([/[-+a-z0-9!*';:=,.$/%[\]_~@|&]*/, /[-+a-z0-9/]/ // Valid ending chars
], {
  match: '*',
  nonCapture: true
})], {
  capture: true,
  match: '?'
});
var URL_QUERY = combinePatterns([/\?/, combinePatterns([VALID_PATH_CHARS, /[a-z0-9_&=]/ // Valid ending chars
], {
  match: '?',
  nonCapture: true
})], {
  capture: true,
  match: '?'
});
var URL_FRAGMENT = combinePatterns([/#/, combinePatterns([VALID_PATH_CHARS, /[a-z0-9]/ // Valid ending chars
], {
  match: '?',
  nonCapture: true
})], {
  capture: true,
  match: '?'
});
var URL_PATTERN = combinePatterns([URL_SCHEME, URL_AUTH, URL_HOST, URL_PORT, URL_PATH, URL_QUERY, URL_FRAGMENT], {
  flags: 'i'
});
var IP_V4_PART = /(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/;
var IP_V4 = combinePatterns([IP_V4_PART, IP_V4_PART, IP_V4_PART, IP_V4_PART], {
  capture: true,
  join: '\\.'
});
var IP_PATTERN = combinePatterns([URL_SCHEME, URL_AUTH, IP_V4, URL_PORT, URL_PATH, URL_QUERY, URL_FRAGMENT], {
  flags: 'i'
});
var HASHTAG_PATTERN = combinePatterns([/#/, combinePatterns([VALID_ALNUM_CHARS, /[-a-z0-9_]*/], {
  capture: true
})], {
  flags: 'i'
});
var EMAIL_USERNAME_PART = /[.a-z0-9!#$%&?*+=_{|}~-]+/;
var EMAIL_USERNAME = combinePatterns([VALID_ALNUM_CHARS, EMAIL_USERNAME_PART, VALID_ALNUM_CHARS], {
  capture: true
});
var EMAIL_PATTERN = combinePatterns([EMAIL_USERNAME, URL_HOST], {
  flags: 'i',
  join: '@'
});
var EMAIL_DISTINCT_PATTERN = new RegExp("^" + EMAIL_PATTERN.source + "$", EMAIL_PATTERN.flags); // Properly and efficiently detecting URLs + all TLDs is nigh impossible,
// instead we will only support the most common top-level TLDs.
// https://en.wikipedia.org/wiki/List_of_Internet_top-level_domains

var TOP_LEVEL_TLDS = [// Original
'com', 'org', 'net', 'int', 'edu', 'gov', 'mil', // Sponsored
'aero', 'asia', 'cat', 'coop', 'jobs', 'mobi', 'museum', 'post', 'tel', 'travel', 'xxx', // Misc
'arpa', 'test', // Countries
'ac', // Ascension Island
'ad', // Andorra
'ae', // United Arab Emirates
'af', // Afghanistan
'ag', // Antigua and Barbuda
'ai', // Anguilla
'al', // Albania
'am', // Armenia
'an', // Netherlands Antilles
'ao', // Angola
'aq', // Antarctica
'ar', // Argentina
'as', // American Samoa
'at', // Austria
'au', // Australia
'aw', // Aruba
'ax', // Aland Islands
'az', // Azerbaijan
'ba', // Bosnia and Herzegovina
'bb', // Barbados
'bd', // Bangladesh
'be', // Belgium
'bf', // Burkina Faso
'bg', // Bulgaria
'bh', // Bahrain
'bi', // Burundi
'bj', // Benin
'bl', // Saint Barthelemy
'bm', // Bermuda
'bn', // Brunei Darussalam
'bo', // Bolivia
'bq', // Bonaire, Sint Eustatius and Saba
'br', // Brazil
'bs', // Bahamas
'bt', // Bhutan
'bv', // Bouvet Island
'bw', // Botswana
'by', // Belarus
'bz', // Belize
'ca', // Canada
'cc', // Cocos (Keeling) Islands
'cd', // Congo, The Democratic Republic of the
'cf', // Central African Republic
'cg', // Congo
'ch', // Switzerland
'ci', // Cote d'Ivoire
'ck', // Cook Islands
'cl', // Chile
'cm', // Cameroon
'cn', // China
'co', // Colombia
'cr', // Costa Rica
'cu', // Cuba
'cv', // Cape Verde
'cw', // Curaçao
'cx', // Christmas Island
'cy', // Cyprus
'cz', // Czech Republic
'de', // Germany
'dj', // Djibouti
'dk', // Denmark
'dm', // Dominica
'do', // Dominican Republic
'dz', // Algeria
'ec', // Ecuador
'ee', // Estonia
'eg', // Egypt
'eh', // Western Sahara
'er', // Eritrea
'es', // Spain
'et', // Ethiopia
'eu', // European Union
'fi', // Finland
'fj', // Fiji
'fk', // Falkland Islands (Malvinas)
'fm', // Micronesia, Federated States of
'fo', // Faroe Islands
'fr', // France
'ga', // Gabon
'gb', // United Kingdom
'gd', // Grenada
'ge', // Georgia
'gf', // French Guiana
'gg', // Guernsey
'gh', // Ghana
'gi', // Gibraltar
'gl', // Greenland
'gm', // Gambia
'gn', // Guinea
'gp', // Guadeloupe
'gq', // Equatorial Guinea
'gr', // Greece
'gs', // South Georgia and the South Sandwich Islands
'gt', // Guatemala
'gu', // Guam
'gw', // Guinea-Bissau
'gy', // Guyana
'hk', // Hong Kong
'hm', // Heard Island and McDonald Islands
'hn', // Honduras
'hr', // Croatia
'ht', // Haiti
'hu', // Hungary
'id', // Indonesia
'ie', // Ireland
'il', // Israel
'im', // Isle of Man
'in', // India
'io', // British Indian Ocean Territory
'iq', // Iraq
'ir', // Iran, Islamic Republic of
'is', // Iceland
'it', // Italy
'je', // Jersey
'jm', // Jamaica
'jo', // Jordan
'jp', // Japan
'ke', // Kenya
'kg', // Kyrgyzstan
'kh', // Cambodia
'ki', // Kiribati
'km', // Comoros
'kn', // Saint Kitts and Nevis
'kp', // Korea, Democratic People's Republic of
'kr', // Korea, Republic of
'kw', // Kuwait
'ky', // Cayman Islands
'kz', // Kazakhstan
'la', // Lao People's Democratic Republic
'lb', // Lebanon
'lc', // Saint Lucia
'li', // Liechtenstein
'lk', // Sri Lanka
'lr', // Liberia
'ls', // Lesotho
'lt', // Lithuania
'lu', // Luxembourg
'lv', // Latvia
'ly', // Libyan Arab Jamahiriya
'ma', // Morocco
'mc', // Monaco
'md', // Moldova, Republic of
'me', // Montenegro
'mf', // Saint Martin (French part)
'mg', // Madagascar
'mh', // Marshall Islands
'mk', // Macedonia, The Former Yugoslav Republic of
'ml', // Mali
'mm', // Myanmar
'mn', // Mongolia
'mo', // Macao
'mp', // Northern Mariana Islands
'mq', // Martinique
'mr', // Mauritania
'ms', // Montserrat
'mt', // Malta
'mu', // Mauritius
'mv', // Maldives
'mw', // Malawi
'mx', // Mexico
'my', // Malaysia
'mz', // Mozambique
'na', // Namibia
'nc', // New Caledonia
'ne', // Niger
'nf', // Norfolk Island
'ng', // Nigeria
'ni', // Nicaragua
'nl', // Netherlands
'no', // Norway
'np', // Nepal
'nr', // Nauru
'nu', // Niue
'nz', // New Zealand
'om', // Oman
'pa', // Panama
'pe', // Peru
'pf', // French Polynesia
'pg', // Papua New Guinea
'ph', // Philippines
'pk', // Pakistan
'pl', // Poland
'pm', // Saint Pierre and Miquelon
'pn', // Pitcairn
'pr', // Puerto Rico
'ps', // Palestinian Territory, Occupied
'pt', // Portugal
'pw', // Palau
'py', // Paraguay
'qa', // Qatar
're', // Reunion
'ro', // Romania
'rs', // Serbia
'ru', // Russian Federation
'rw', // Rwanda
'sa', // Saudi Arabia
'sb', // Solomon Islands
'sc', // Seychelles
'sd', // Sudan
'se', // Sweden
'sg', // Singapore
'sh', // Saint Helena
'si', // Slovenia
'sj', // Svalbard and Jan Mayen
'sk', // Slovakia
'sl', // Sierra Leone
'sm', // San Marino
'sn', // Senegal
'so', // Somalia
'sr', // Suriname
'st', // Sao Tome and Principe
'su', // Soviet Union (being phased out)
'sv', // El Salvador
'sx', // Sint Maarten (Dutch part)
'sy', // Syrian Arab Republic
'sz', // Swaziland
'tc', // Turks and Caicos Islands
'td', // Chad
'tf', // French Southern Territories
'tg', // Togo
'th', // Thailand
'tj', // Tajikistan
'tk', // Tokelau
'tl', // Timor-Leste
'tm', // Turkmenistan
'tn', // Tunisia
'to', // Tonga
'tp', // Portuguese Timor (being phased out)
'tr', // Turkey
'tt', // Trinidad and Tobago
'tv', // Tuvalu
'tw', // Taiwan, Province of China
'tz', // Tanzania, United Republic of
'ua', // Ukraine
'ug', // Uganda
'uk', // United Kingdom
'um', // United States Minor Outlying Islands
'us', // United States
'uy', // Uruguay
'uz', // Uzbekistan
'va', // Holy See (Vatican City State)
'vc', // Saint Vincent and the Grenadines
've', // Venezuela, Bolivarian Republic of
'vg', // Virgin Islands, British
'vi', // Virgin Islands, U.S.
'vn', // Viet Nam
'vu', // Vanuatu
'wf', // Wallis and Futuna
'ws', // Samoa
'ye', // Yemen
'yt', // Mayotte
'za', // South Africa
'zm', // Zambia
'zw' // Zimbabwe
];

var EmailMatcher = /*#__PURE__*/function (_Matcher) {
  _inheritsLoose(EmailMatcher, _Matcher);

  function EmailMatcher() {
    return _Matcher.apply(this, arguments) || this;
  }

  var _proto = EmailMatcher.prototype;

  _proto.replaceWith = function replaceWith(children, props) {
    return /*#__PURE__*/React.createElement(Email, props, children);
  };

  _proto.asTag = function asTag() {
    return 'a';
  };

  _proto.match = function match(string) {
    return this.doMatch(string, EMAIL_PATTERN, function (matches) {
      return {
        email: matches[0],
        emailParts: {
          host: matches[2],
          username: matches[1]
        }
      };
    });
  };

  return EmailMatcher;
}(Matcher);

function Hashtag(_ref3) {
  var children = _ref3.children,
      _ref3$encodeHashtag = _ref3.encodeHashtag,
      encodeHashtag = _ref3$encodeHashtag === void 0 ? false : _ref3$encodeHashtag,
      hashtag = _ref3.hashtag,
      _ref3$hashtagUrl = _ref3.hashtagUrl,
      hashtagUrl = _ref3$hashtagUrl === void 0 ? '{{hashtag}}' : _ref3$hashtagUrl,
      _ref3$preserveHash = _ref3.preserveHash,
      preserveHash = _ref3$preserveHash === void 0 ? false : _ref3$preserveHash,
      props = _objectWithoutPropertiesLoose(_ref3, ["children", "encodeHashtag", "hashtag", "hashtagUrl", "preserveHash"]);

  var tag = hashtag; // Prepare the hashtag

  if (!preserveHash && tag.charAt(0) === '#') {
    tag = tag.slice(1);
  }

  if (encodeHashtag) {
    tag = encodeURIComponent(tag);
  } // Determine the URL


  var url = hashtagUrl || '{{hashtag}}';
  url = typeof url === 'function' ? url(tag) : url.replace('{{hashtag}}', tag);
  return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
    href: url
  }), children);
}

var HashtagMatcher = /*#__PURE__*/function (_Matcher2) {
  _inheritsLoose(HashtagMatcher, _Matcher2);

  function HashtagMatcher() {
    return _Matcher2.apply(this, arguments) || this;
  }

  var _proto2 = HashtagMatcher.prototype;

  _proto2.replaceWith = function replaceWith(children, props) {
    return /*#__PURE__*/React.createElement(Hashtag, props, children);
  };

  _proto2.asTag = function asTag() {
    return 'a';
  };

  _proto2.match = function match(string) {
    return this.doMatch(string, HASHTAG_PATTERN, function (matches) {
      return {
        hashtag: matches[0]
      };
    });
  };

  return HashtagMatcher;
}(Matcher);

function Url(_ref4) {
  var children = _ref4.children,
      url = _ref4.url,
      urlParts = _ref4.urlParts,
      props = _objectWithoutPropertiesLoose(_ref4, ["children", "url", "urlParts"]);

  var href = url;

  if (!href.match(/^https?:\/\//)) {
    href = "http://" + href;
  }

  return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
    href: href
  }), children);
}

var UrlMatcher = /*#__PURE__*/function (_Matcher3) {
  _inheritsLoose(UrlMatcher, _Matcher3);

  function UrlMatcher(name, options, factory) {
    return _Matcher3.call(this, name, _extends2({
      customTLDs: [],
      validateTLD: true
    }, options), factory) || this;
  }

  var _proto3 = UrlMatcher.prototype;

  _proto3.replaceWith = function replaceWith(children, props) {
    return /*#__PURE__*/React.createElement(Url, props, children);
  };

  _proto3.asTag = function asTag() {
    return 'a';
  };

  _proto3.match = function match(string) {
    var response = this.doMatch(string, URL_PATTERN, this.handleMatches); // False positives with URL auth scheme

    if (response != null && response.match.match(EMAIL_DISTINCT_PATTERN)) {
      response.valid = false;
    }

    if (response && this.options.validateTLD) {
      var host = response.urlParts.host;
      var validList = TOP_LEVEL_TLDS.concat(this.options.customTLDs || []);
      var tld = host.slice(host.lastIndexOf('.') + 1).toLowerCase();

      if (!validList.includes(tld)) {
        return null;
      }
    }

    return response;
  }
  /**
   * Package the matched response.
   */
  ;

  _proto3.handleMatches = function handleMatches(matches) {
    return {
      url: matches[0],
      urlParts: {
        auth: matches[2] ? matches[2].slice(0, -1) : '',
        fragment: matches[7] || '',
        host: matches[3],
        path: matches[5] || '',
        port: matches[4] ? matches[4] : '',
        query: matches[6] || '',
        scheme: matches[1] ? matches[1].replace('://', '') : 'http'
      }
    };
  };

  return UrlMatcher;
}(Matcher);

var IpMatcher = /*#__PURE__*/function (_UrlMatcher) {
  _inheritsLoose(IpMatcher, _UrlMatcher);

  function IpMatcher(name, options, factory) {
    return _UrlMatcher.call(this, name, _extends2({}, options, {
      // IPs dont have TLDs
      validateTLD: false
    }), factory) || this;
  }

  var _proto4 = IpMatcher.prototype;

  _proto4.match = function match(string) {
    return this.doMatch(string, IP_PATTERN, this.handleMatches);
  };

  return IpMatcher;
}(UrlMatcher);

export { EMAIL_DISTINCT_PATTERN, EMAIL_PATTERN, EMAIL_USERNAME, EMAIL_USERNAME_PART, Email, EmailMatcher, HASHTAG_PATTERN, Hashtag, HashtagMatcher, IP_PATTERN, IP_V4, IP_V4_PART, IpMatcher, Link, TOP_LEVEL_TLDS, URL_AUTH, URL_FRAGMENT, URL_HOST, URL_PATH, URL_PATTERN, URL_PORT, URL_QUERY, URL_SCHEME, Url, UrlMatcher, VALID_ALNUM_CHARS, VALID_PATH_CHARS, combinePatterns };
//# sourceMappingURL=index.js.map
